var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrap" }, [
    _c("img", { attrs: { src: require("./imgs/15@3x.png"), alt: "" } }),
    _c("div", { staticClass: "bt-group" }, [
      _c("p", [_vm._v("您是否对此活动感兴趣？")]),
      _c("div", { staticClass: "bt-wrap" }, [
        _c("img", {
          attrs: { src: require("./imgs/ac2.png"), alt: "" },
          on: {
            click: function($event) {
              return _vm.interested(false)
            }
          }
        }),
        _c("img", {
          attrs: { src: require("./imgs/ac1.png"), alt: "" },
          on: {
            click: function($event) {
              return _vm.interested(true)
            }
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }